export const screen_datas = [
    {
        label: 'Home',
        value: 'Home'
    },
    {
        label: 'Inbox',
        value: 'Inbox'
    },
    {
        label: 'Mycar',
        value: 'Mycar'
    },
    {
        label: 'Profile',
        value: 'Profile'
    },
    {
        label: 'Calendar',
        value: 'Calendar'
    },
    {
        label: 'Recovery',
        value: 'Recovery'
    },
    {
        label: 'ShareLocation',
        value: 'ShareLocation'
    },
    {
        label: 'HistoryDocument',
        value: 'HistoryDocument'
    },
    {
        label: 'DocumentDetail',
        value: 'DocumentDetail'
    },
    {
        label: 'Fuel Price Locator',
        value: 'Fuel'
    },
    {
        label: 'LevelOfCover',
        value: 'LevelOfCover'
    },
    {
        label: 'AU Warranty',
        value: 'AUWarranty'
    },
    {
        label: 'MakeAClaim',
        value: 'MakeAClaim'
    },
    {
        label: 'YourCover',
        value: 'YourCover'
    },
    {
        label: 'WarrantyArea',
        value: 'WarrantyArea'
    },
    {
        label: 'VehicleInfo',
        value: 'VehicleInfo'
    },
    {
        label: 'Electroverse',
        value: 'Electroverse'
    },
    {
        label: 'Customise',
        value: 'Customise'
    },
]